/* Ce composant permet d'insérer des graphiques simples de type "camembert" ou "en barre"
 * Il a besoin de deux données :
 *   - Mode --> permet de définir la méthode du serveur à appeler
 *   - Id --> Liste d'ident pour effectuer les requêtes
 *
 * A l'init, il reçoit du serveur les données pour le graphique et le type de graphique : PIE (équivalent camembert) ou BAR (en barre)
 * Il utilise alors un des templates d'option pour afficher le graphique
 *
 */

import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, ViewChild } from '@angular/core';
import * as echarts from 'echarts';
import { QResult } from '../models';
import { EchartData, EchartModel } from '../models/echartModel/echart.model';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast';



@Component({
  selector: 'basic-echart',
  templateUrl: './basic-echart.component.html',
  styleUrls: ['./basic-echart.component.css']
})
export class BasicEchartComponent implements OnInit {

  @ViewChild('graph', { static: false }) graph: ElementRef;
  myChart: echarts.EChartsType;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.chartResizer();
  }

  // Chemin pour la récupération des données depuis l'API
  @Input() Mode: string;
  // Liste des ident nécéssaires pour la/les requête(s)
  @Input() Id: string;

  // Ajout text au centre du chart "pie"
  @Input() TextTitlePieCenter: string;

  // Données pour le graphique
  public ChartData: Array<EchartData>;
  //sert à savoir si le container parent est un carré pour l'emplacement des éléments (responsive)
  public ContainerIsSquare: boolean = false;

  constructor(
    protected renderer: Renderer2,
    private http: HttpService,
    private core: CoreService,
    private toast: ToastService,
  ) { }

  ngOnInit(): void {
    this.ChartData = new Array<EchartData>();
    this.http.getHttp<QResult<EchartModel>>(`${this.core.AppParams.apiUrl}api/echart/${this.Mode}/${this.Id}`)
      .subscribe((result: QResult<EchartModel>) => {
        if (!result.HasError) {
          this.ChartData = result.Value.EchartDatas;
          this.chartConstructor();
        } else {
          this.toast.showWarningToast("Erreur lors de la récupération des données du graphique", 5000);
        }
      });
  }


  private chartResizer(): void {
    const interval = setInterval(() => {
      //get size parent container
      if (this.graph) {


        const width = this.graph.nativeElement.parentElement.parentElement.clientWidth;
        const height = this.graph.nativeElement.parentElement.parentElement.clientHeight;
        var centerHorizontal: string = "30%";
        if (width > 0 && height > 0) {
          (width / height) < 1.5 ? this.ContainerIsSquare = true : this.ContainerIsSquare = false;
        }
        if (width >= 300 && width <= 420) {
          this.ContainerIsSquare = true;
        }
        this.ContainerIsSquare ? centerHorizontal = "50%" : centerHorizontal = "30%";
        const isRatioDoubleH: boolean = width <= 2.3 * height;
        if (width > 0 && height > 0) {
          clearInterval(interval);
          this.renderer.setStyle(this.graph.nativeElement, 'width', `${width}px`);
          this.renderer.setStyle(this.graph.nativeElement, 'height', `${height}px`);

          if (this.ContainerIsSquare) {
            this.myChart.setOption({
              
              title: {
                text: this.TextTitlePieCenter,
                top: 'center',
                left: `center`,
                textAlign: 'absolute',
                show: this.TextTitlePieCenter != null && this.TextTitlePieCenter != undefined && this.TextTitlePieCenter.length > 0
              },
              legend: {
                top: '-5',
                left: 'center',
                type: 'scroll',
                orient: 'horizontal'
              },
              series: [
                {
                  top: 'center',
                  left: 'center',
                  height: 180,
                  width: 180,
                  center: [centerHorizontal, '55%'],
                }
              ]
            });
          } else {
            this.myChart.setOption({
              legend: {
                top: 'center',
                left: isRatioDoubleH ? '50%': '35%',
                orient: 'vertical',
                icon: 'circle',
                show: true,
              },
              title: {
                text: this.TextTitlePieCenter,
                top: 'center',
                left: isRatioDoubleH ? '20%' : '12%',
                /*left: `${width/5-50}px`,*/
                textAlign: 'centerHorizontal',
                show: this.TextTitlePieCenter != null && this.TextTitlePieCenter != undefined && this.TextTitlePieCenter.length > 0
              },
              series: [
                {
                  left: isRatioDoubleH ? '15%' : '10%',
                  height: 200,
                  width: 200,
                  center: [centerHorizontal, '45%'],
                }
              ]
            });
          }

          this.myChart.resize();
        }
      }
    }, 100);

  }


  private chartConstructor(): void {

    // setTimeout pour faire un aller retour sur le html 
    setTimeout(() => {
      //get size parent container
      if (this.graph) {
        const widthParent = this.graph.nativeElement.parentElement.parentElement.clientWidth;
        const heightParent = this.graph.nativeElement.parentElement.parentElement.clientHeight;
        var centerHorizontal: string = "30%";
        if (widthParent > 0 && heightParent > 0) {
          (widthParent / heightParent) < 1.5 ? this.ContainerIsSquare = true : this.ContainerIsSquare = false;
        }
        this.ContainerIsSquare ? centerHorizontal = "50%" : centerHorizontal = "35%";
        //init chart
        this.myChart = echarts.init(this.graph.nativeElement);

        this.myChart.setOption({
          title: {
            text: this.TextTitlePieCenter,
            top: 'center',
            left: this.ContainerIsSquare ? `center` : `${widthParent / 5 - 30}px`,
            show: this.TextTitlePieCenter != null && this.TextTitlePieCenter != undefined && this.TextTitlePieCenter.length > 0
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '0',
            left: 'center',
            type: 'scroll',
            orient: 'horizontal',
            padding: [8, 20],
            textStyle: {
              fontSize: 15,
            },

          },
          series: [
            {
              type: 'pie',
              top: '10',
              left: 'center',
              radius: ['60%', '90%'],
              height: 'auto',
              width: 'auto',
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                //formatter: '{c}',
                formatter: function (param: any) {
                  return param.data.value == 0 ? '' : param.data.value;
                },
                fontSize: 16,
                position: 'inner',
                distance: 0.5,
                fontWeight: 'bold'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 18,
                  fontWeight: 'bolder'
                }
              },
              data: this.ChartData,
              center: [centerHorizontal, '50%']
            },
          ]
        });

        this.chartResizer();
      }
    }, 1);
  }



}

